import React, { Fragment } from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { VideoMetadata } from './video-metadata';
import { VideoRating } from 'components/video-player/rate-video/video-rating';
import { myVideosAverageRating } from 'pages/my-videos.page/selectors';
import { VideoItemGeneratingThumbnail } from 'components/video-generating/video-generating-thumbnail';
import { VideoPlayerWrapper } from 'components/video-player/video-player-wrapper';

export const VideoPreviewHeader = connect(
  (state) => ({
    rating: myVideosAverageRating(state),
  }),
  false
)(({ video, playerConfiguration, withRating, rating, thumbnailUrl }) => {
  const { t } = useTranslation();

  if (!video) {
    return null;
  }

  return (
    <Fragment>
      <h1 data-e2e="video-title">
        {t('edit')}: {video.title}
      </h1>
      <div data-e2e="video-preview" className="row no-gutters ct-my-videos-page__video-preview">
        <div data-e2e="video-preview-player" className="col-5 ct-my-videos-page__video-preview__player">
          {!thumbnailUrl ? (
            <VideoItemGeneratingThumbnail />
          ) : (
            <VideoPlayerWrapper playerConfiguration={playerConfiguration} video={video} />
          )}
        </div>
        <div className="col ct-my-videos-page__video-preview__meta">
          <VideoMetadata video={video} />
          {withRating && <VideoRating userRating={rating} readonly={true} showStats={false} />}
        </div>
      </div>
    </Fragment>
  );
});

VideoPreviewHeader.propTypes = {
  video: PropTypes.object,
  playerConfiguration: PropTypes.object.isRequired,
  withRating: PropTypes.bool.isRequired,
};
